import Loadable from '@townsquare/loadable';
import { searchRoute } from '@townsquare/routes/search';
import { goalsAppGlobalSearchRoute } from '@townsquare/routes/search-goals-app';
import { projectsAppGlobalSearchRoute } from '@townsquare/routes/search-projects-app';
import { teamsAppGlobalSearchRoute } from '@townsquare/routes/search-teams-app';

const SearchView = Loadable({
	loader: () => import(/* webpackChunkName: "search-view" */ './SearchView'),
	loading: () => null,
});

searchRoute.component = SearchView;
searchRoute.resources = [];
export const searchRouterRoute = searchRoute;

teamsAppGlobalSearchRoute.component = SearchView;
teamsAppGlobalSearchRoute.resources = [];
export const teamsAppGlobalSearchRouterRoute = teamsAppGlobalSearchRoute;

goalsAppGlobalSearchRoute.component = SearchView;
goalsAppGlobalSearchRoute.resources = [];
export const goalsAppGlobalSearchRouterRoute = goalsAppGlobalSearchRoute;

projectsAppGlobalSearchRoute.component = SearchView;
projectsAppGlobalSearchRoute.resources = [];
export const projectsAppGlobalSearchRouterRoute = projectsAppGlobalSearchRoute;
